import Cookies from 'js-cookie'

export default class Features {
  constructor(features) {
    this._features = {} // internal list
    this.COOKIE_SHELF_LIFE = 365 // one year

    Object.keys(features).forEach((featureName) => {
      switch (Cookies.get(featureName)) {
        case 'true':
          this._features[featureName] = true
          break
        case 'false':
          this._features[featureName] = false
          break
        default:
          this._features[featureName] = features[featureName]
      }
    })
  }

  enable(featureName) {
    this._features[featureName] = true
    Cookies.set(featureName, true, {expires: this.COOKIE_SHELF_LIFE})
  }

  disable(featureName) {
    this._features[featureName] = false
    Cookies.set(featureName, false, {expires: this.COOKIE_SHELF_LIFE})
  }

  enabled(featureName) {
    return this._features[featureName] === true
  }

  disabled(featureName) {
    return !(this._features[featureName] === true)
  }

  dump() {
    return this._features
  }

  clear() {
    Object.keys(this._features).forEach((featureName) => {
      Cookies.remove(featureName)
    })
    this._features = {}
  }
}
